namespace GeniuzPOS.Lookups {
    export interface VwPaytermCodeLookupRow {
        Id?: number;
        PayTermCode?: string;
        PayTermDesc?: string;
        CreditTerm?: number;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        LookupName?: string;
    }

    export namespace VwPaytermCodeLookupRow {
        export const idProperty = 'PayTermCode';
        export const nameProperty = 'LookupName';
        export const localTextPrefix = 'Purchase.VwPaytermCodeLookup';
        export const lookupKey = 'Purchase.VwPaytermCodeLookup';

        export function getLookup(): Q.Lookup<VwPaytermCodeLookupRow> {
            return Q.getLookup<VwPaytermCodeLookupRow>('Purchase.VwPaytermCodeLookup');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            Id = "Id",
            PayTermCode = "PayTermCode",
            PayTermDesc = "PayTermDesc",
            CreditTerm = "CreditTerm",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            LookupName = "LookupName"
        }
    }
}
